<template>
		<div class="menuContentBox">
			<div class="correntItem" :class="{active:btnStart==1}" @mouseover="btnStart=1">
				<div class="itemChird" @click="goMore('/finance/index')">

					<h3><img src="@/assets/img/jf/ico_kjcx.png">科技金融</h3>
					<p>
						推动创新创业活动，增创发展新优势，集成式服务。以需求为引导、企业为主体、市场为导向、产学研深度融合的技术创新体系，加速科技成果转化，推动产业转型升级。
					</p>
					<a-button>了解更多</a-button>
				</div>
				<div class="itemChirdbtm">
					<h3><img src="@/assets/img/jf/ico_kjcx.png">科技金融</h3>
				</div>
			</div>
			<div class="correntItem" :class="{active:btnStart==2}" @mouseover="btnStart=2">
				<div class="itemChird" @click="goMore('/integral/pyku','企业培育库')">
					<!-- <div class="itemChird"> -->

					<h3><img src="@/assets/img/jf/ico_qypy.png">企业培育库</h3>
					<p>
						精准遴选目标，加强入库企业精准对接、培育辅导，助推科技型企业提档升级。
					</p>
					<a-button>了解更多</a-button>
				</div>
				<div class="itemChirdbtm">
					<h3><img src="@/assets/img/jf/ico_qypy.png">企业培育库</h3>
				</div>
			</div>
		</div>
</template>

<script>
export default {
	name: "index",
	components: {
		// DictRender

	},
	data() {
		return {
			btnStart:1,
			correntShow:0,
		}
	},
	mounted() {
	},
	methods: {
		goMore(url, key, id) {
			this.$router.push({
				path: url,
				query: { type: key, queryData: id }
			})
		},
	}
}
</script>

<style scoped lang="less">
.menuContentBox{
	position: relative;
	height:300px!important;
	display: flex;
	width:1400px!important;
	margin:30px auto!important;
	overflow: hidden;
}
.correntItem{
	position: relative;
	background: url(../../../../assets/img/jf/jf_kjcx.jpg);
	height:100%;
	height:300px;
	flex:1;
	transition: flex .8s,-webkit-box-flex .8s,-ms-flex .8s;
	transition: opacity .8s;
	margin:0;
	&:nth-child(2){
		margin-left:30px;
		background: url(../../../../assets/img/jf/jf_qypy.jpg);
	}
	.itemChirdbtm{
		background-color: rgba(0,0,0,.6);
		width:100%;
		height:50px;
		position: absolute;
		bottom: 0;
		h3{
			position: relative;
			img{
				position: absolute;
				height:30px;
				left:-40px;
				top:3px;
				vertical-align: middle;
			}
			color:#fff;
			margin-left: 60px;
			margin-top:5px;
		}
	}
	.itemChird{
		background-color: rgba(0,0,0,.6);
		width: 100%;
		height:300px;
		cursor: pointer;
		transition: margin-top .7s;
		margin-top: 300px;
		h3{
			position: relative;
			img{
				position: absolute;
				height:30px;
				left:-40px;
				top:30px;
				vertical-align: middle;
			}
			color:#fff;
			width:76%;
			margin:0 auto;
			padding-top: 30px;
		}
		p{
			color:#fff;
			width:90%;
			margin:30px auto;
			font-size: 16px;
			word-break: break-all;
			overflow:hidden;
			text-overflow:ellipsis;
			display:-webkit-box;
			-webkit-box-orient:vertical;
			-webkit-line-clamp:3;
			height: 75px;
		}
		button{
			margin-left:30px;
			padding: 5px 25px;
			height: 40px;
			color:#1890ff
		}
	}
	&:hover{
		.itemChirdbtm{
			opacity: 0;
		}
		.itemChird{
			margin-top: 0;
		}
	}
}

:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
	border-bottom: 3px solid #1890ff
}

:deep(.ant-menu-item-selected) {
	font-weight: 600;
}

:deep(.ant-btn) {
	border-radius: 0;
}
</style>
